import { theme } from "../ui";
import type { ReactNode } from "react";
import { spacing } from "./spacing";

/**
 * Roter Rahmen um den Arbeitsbereich, solange er gesperrt ist (Tarif beendet, Standort gesperrt).
 * Der Rahmen ist die durchgehende Markierung; den Grund nennt ein Hinweis darüber.
 */
export function LockedContentFrame({ locked, children }: { locked: boolean; children: ReactNode }) {
  const { token } = theme.useToken();
  if (!locked) return <>{children}</>;
  return (
    <div
      style={{
        outline: `${token.lineWidthBold}px solid ${token.colorError}`,
        outlineOffset: spacing.tightGap,
        borderRadius: token.borderRadiusLG,
        minHeight: "100%",
      }}
    >
      {children}
    </div>
  );
}
